module.exports = __webpack_public_path__ + "img/ZH.34fac728.png";